import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./style/main.css";
import "./assets/styles/index.css";
import App from "./App";

//added the react-router package and wrap the entire app using the browserrouter

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
